const REVIEW_DEBUG_QUERY_PARAM = "reviewDebug";
const REVIEW_DEBUG_STORAGE_KEY = "fv.review.debug";

const isTruthyDebugValue = (value) => (
  value === true
  || value === "1"
  || value === "true"
  || value === "yes"
  || value === "on"
);

export const isReviewDebugEnabled = () => {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    if (isTruthyDebugValue(window.__FV_REVIEW_DEBUG__)) {
      return true;
    }

    const params = new URLSearchParams(window.location.search || "");
    if (isTruthyDebugValue(params.get(REVIEW_DEBUG_QUERY_PARAM))) {
      return true;
    }

    if (isTruthyDebugValue(window.localStorage?.getItem(REVIEW_DEBUG_STORAGE_KEY))) {
      return true;
    }

    if (isTruthyDebugValue(window.sessionStorage?.getItem(REVIEW_DEBUG_STORAGE_KEY))) {
      return true;
    }
  } catch (error) {
    return false;
  }

  return false;
};

export const debugReview = (eventName, payload = {}) => {
  if (!isReviewDebugEnabled()) {
    return;
  }

  try {
    console.info(`[ReviewDebug] ${eventName}`, payload);
  } catch (error) {
    // Ignore console failures in restrictive environments.
  }
};

export const REVIEW_DEBUG_STORAGE = REVIEW_DEBUG_STORAGE_KEY;
